import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageValidation from '@/icons/PackageValidation.svg';

export const ShipmentArticleVerifiedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'shipment_article_verified'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconPackageValidation />}
      message={
        <>
          <BaseActivityText>
            <Trans id="activities.shipment_article_verified.message">
              <strong>{creatorName}</strong> verified the item
            </Trans>
          </BaseActivityText>
          <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
        </>
      }
    />
  );
};
